'use strict';

exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _Grid = require('react-bootstrap/lib/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _Col = require('react-bootstrap/lib/Col');

var _Col2 = _interopRequireDefault(_Col);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _components = require('components');

var _mozart_ui = require('@pgforsta/mozart_ui');

var _survey = require('redux/modules/survey');

var _utilElement = require('utils/util-element.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Locations = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    locations: state.survey.locations,
    survey: state.survey.data
  };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)({ loadLocations: _survey.loadLocations }, dispatch);
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Locations, _Component);

  function Locations(props) {
    (0, _classCallCheck3.default)(this, Locations);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.styles = require('./Locations.scss');
    _this.state = {
      hover: false,
      cardId: '',
      height: window.innerHeight || document.documentElement.clientHeight,
      width: window.innerWidth || document.documentElement.clientWidth,
      device_type: (window.innerWidth || document.documentElement.clientWidth) < 992 ? 'mobile' : 'desktop',
      selected_location: _this.props.selectedLocation,
      search_text: false,
      show_search: _this.props.showSearch ? _this.props.showSearch : false
    };
    (0, _utilElement.fireGTMEvent)(_utilElement.EVENT_PAGE_LOAD, _utilElement.EVENT_PAGE_LOAD, 'Loading locations listing page.');
    return _this;
  }

  Locations.prototype.componentDidMount = function componentDidMount() {
    if (!this.props.locations) {
      this.props.loadLocations(this.props.clientId, this.props.sourceId);
    }
  };

  Locations.prototype.setLocation = function setLocation(location) {
    this.setState({ selected_location: location.id });
    this.props.onSelectLocation(location);
  };

  Locations.prototype.getSingleLocation = function getSingleLocation(location) {
    return _react2.default.createElement(
      _Col2.default,
      { xs: 12, sm: 6, md: 4, lg: 4 },
      _react2.default.createElement(
        'div',
        { 'data-qa-type': 'list_item', title: location.name, className: this.state.selected_location === location.id ? this.styles.location_container + ' ' + this.styles.location_selected : this.styles.location_container,
          onClick: this.setLocation.bind(this, location),
          onMouseEnter: this.handleMouseEnter.bind(this, location),
          onMouseLeave: this.handleMouseLeave.bind(this),
          id: location.id },
        _react2.default.createElement(
          'div',
          { className: this.styles.location_id },
          location.id
        ),
        _react2.default.createElement(
          'div',
          { className: this.styles.location_name },
          location.name
        ),
        _react2.default.createElement(
          'div',
          { className: this.styles.location_address },
          location.address
        )
      )
    );
  };

  Locations.prototype.getLocations = function getLocations() {
    var _this2 = this;

    var locations = this.props.locations;

    var locationElem = [];
    if (locations && locations.data.length) {
      locations.data.map(function (item) {
        if (_this2.state.search_text) {
          if (item.name.toLowerCase().search(_this2.state.search_text.toLowerCase()) !== -1) {
            locationElem.push(_this2.getSingleLocation(item));
          }
        } else {
          locationElem.push(_this2.getSingleLocation(item));
        }
      });
    } else {
      locationElem.push(_react2.default.createElement(
        'p',
        null,
        'This practice/brand does not appear to have locations that administer surveys. Please contact your practice/brand for assistance.'
      ));
    }
    if (!locationElem.length) {
      locationElem.push(_react2.default.createElement(
        'p',
        { className: this.styles.no_locations },
        'Sorry ! no items found.'
      ));
    }
    return locationElem;
  };

  Locations.prototype.handleSearch = function handleSearch(searchText) {
    if (searchText.length >= 1 || searchText === '') {
      this.setState({ search_text: searchText, show_search: false });
    }
  };

  Locations.prototype.handleMouseEnter = function handleMouseEnter(location) {
    this.setState({ cardId: location.id });
    document.getElementById(location.id).style.border = '1px solid' + this.props.theme.colorCode;
  };

  Locations.prototype.handleMouseLeave = function handleMouseLeave() {
    document.getElementById(this.state.cardId).style.border = '1px solid #E5E5E5';
  };

  Locations.prototype.render = function render() {
    var _this3 = this;

    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { className: this.styles.locations_page_container, style: { width: '100%' }, id: 'locations_listing_page' },
        _react2.default.createElement(
          _Grid2.default,
          null,
          _react2.default.createElement(
            'div',
            { className: this.styles.location_wrapper },
            !this.state.show_search && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _Row2.default,
                { className: this.styles.location_header_container, style: { width: '90%', position: 'inherit' } },
                _react2.default.createElement(
                  _Col2.default,
                  { xs: 12, sm: 8, md: 8, lg: 8 },
                  _react2.default.createElement(
                    'span',
                    { className: this.styles.location_heading },
                    this.props.label
                  )
                ),
                _react2.default.createElement(
                  _Col2.default,
                  { xs: 12, sm: 4, md: 4, lg: 4, xsHidden: true },
                  _react2.default.createElement(
                    'div',
                    { className: this.styles.search_container },
                    _react2.default.createElement(_components.Search, {
                      label: '',
                      placeholder: 'Search',
                      handleSearch: this.handleSearch.bind(this),
                      style: { 'float': 'right', 'marginRight': '-15px' }
                    })
                  )
                )
              ),
              _react2.default.createElement(
                _Row2.default,
                {
                  className: this.styles.location_list_container, 'data-qa-type': 'list_container' },
                this.getLocations()
              )
            ),
            this.state.show_search && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _Row2.default,
                { className: this.styles.location_header_container, style: { width: '90%' } },
                _react2.default.createElement(
                  _Col2.default,
                  { xs: 12, smHidden: true, mdHidden: true, lgHidden: true, style: { marginTop: '20px' } },
                  _react2.default.createElement(
                    'span',
                    { className: this.styles.location_heading },
                    'Search a practice/location'
                  )
                )
              ),
              _react2.default.createElement(
                _Row2.default,
                { className: this.styles.location_list_container + ' mobile_search_elements' },
                _react2.default.createElement(
                  _Col2.default,
                  { xs: 12, smHidden: true, mdHidden: true, lgHidden: true, className: 'mobile_search_text_field' },
                  _react2.default.createElement(_mozart_ui.MozartTextBox, {
                    ref: 'textbox_mobile_search',
                    id: 'textbox_mobile_search',
                    multiLine: false,
                    validationBool: false,
                    key: 'textbox_mobile_search',
                    limit: 100
                  })
                ),
                _react2.default.createElement(
                  _Col2.default,
                  { xs: 6, tabindex: '0', smHidden: true, mdHidden: true, lgHidden: true, className: 'mobile_search_button' },
                  _react2.default.createElement(_mozart_ui.MozartButton, {
                    style: { border: '1px solid ' + this.props.theme.colorCode },
                    background: this.props.theme && this.props.theme.colorCode ? this.props.theme.colorCode : true,
                    data: 'Cancel',
                    onClick: function onClick() {
                      if (document.getElementById('textbox_mobile_search')) {
                        _this3.handleSearch('');
                      }
                    }
                  })
                ),
                _react2.default.createElement(
                  _Col2.default,
                  { xs: 6, smHidden: true, mdHidden: true, lgHidden: true, className: 'mobile_search_button' },
                  _react2.default.createElement(_mozart_ui.MozartButton, {
                    style: { border: '1px solid ' + this.props.theme.colorCode },
                    background: this.props.theme && this.props.theme.colorCode ? this.props.theme.colorCode : true,
                    data: 'Search',
                    onClick: function onClick() {
                      if (document.getElementById('textbox_mobile_search')) {
                        _this3.handleSearch(document.getElementById('textbox_mobile_search').value);
                      }
                    }
                  })
                )
              )
            )
          )
        )
      )
    );
  };

  return Locations;
}(_react.Component), _class2.propTypes = {
  onSelectLocation: _react.PropTypes.func,
  loadLocations: _react.PropTypes.func,

  locations: _react.PropTypes.object,
  survey: _react.PropTypes.object,

  selectedLocation: _react.PropTypes.number,

  theme: _react.PropTypes.string,
  clientId: _react.PropTypes.string,
  sourceId: _react.PropTypes.string,
  label: _react.PropTypes.string,

  showSearch: _react.PropTypes.bool
}, _temp)) || _class);
exports.default = Locations;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Locations/Locations.js
// module id = 2330
// module chunks = 0